import { Button, Stack } from "@mantine/core";
import { IconSettings } from "@tabler/icons-react";
import React from "react";
import { useDocumentModalStore } from "@pages/ClientProfile/components/Sidebar/DocumentPopover/useDocumentModalStore.ts";

const DocumentSectionItemPopover: React.FC = () => {
  const { openDocumentActions, setDocumentPopoverId } = useDocumentModalStore();

  const handleOpenActions = (): void => {
    setDocumentPopoverId(null); // Close the popover first
    openDocumentActions(); // Then open the modal
  };

  return (
    <>
      <Stack pt={10} pb={10}>
        <Button
          variant="transparent"
          color="black"
          fw={400}
          rightSection={<IconSettings />}
          fullWidth
          justify="space-between"
          onClick={(e) => {
            e.stopPropagation(); // Prevent click from bubbling to document row
            handleOpenActions();
          }}
        >
          Document Actions
        </Button>
      </Stack>
    </>
  );
};

export default DocumentSectionItemPopover;
